import {
  Component,
  Input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Column } from '../../model/common/column';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputText } from '@openng/optimus-ui/inputtext';
import { Select } from '@openng/optimus-ui/select';
import { CalendarComponent } from './calendar.component';

export type FilterEvent = {
  value: string | null;
  field: string;
  matchMode?: string;
  operator?: string;
};

@Component({
  selector: 'app-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    InputText,
    Select,
    CalendarComponent,
    ReactiveFormsModule,
  ],
})
export class TableFilterComponent {
  @Input() col!: Column;
  readonly filterEvent = output<FilterEvent>();

  getStyleClass(col: Column) {
    if (col.formControl && col.formControl.invalid) {
      return 'lookup-filter-error ui-inputtext ui-corner-all ui-state-default ui-widget';
    } else {
      return 'ui-inputtext ui-corner-all ui-state-default ui-widget';
    }
  }

  emitInputFilter($event: Event, col: Column) {
    this.filterEvent.emit({
      value: (<HTMLInputElement>$event.target).value,
      field: col.field,
      matchMode: col.matchMode,
    });
  }
}
